/**
 * The map of ZppLocale - PayPal supported locale. Used to convert the Zpp Locale to PayPal locale.
 */
/* There are some locales that are not supported by PayPal, we need to build a map to overcome the
 * limitation. See the references:
 * - Jira ticket where the problem is described: https://tracker.zooplus.de/browse/SC-2465
 * - PayPal JS SDK supported locale docs: https://developer.paypal.com/sdk/js/configuration/#link-locale */
const payPalLocaleOfZppLocale = {
    'bg-BG': 'en_BG',
    'cs-CZ': 'cs_CZ',
    'da-DK': 'da_DK',
    'de-AT': 'de_AT',
    'de-CH': 'de_CH',
    'de-DE': 'de_DE',
    'el-GR': 'el_GR',
    'en-GB': 'en_GB',
    'en-IE': 'en_IE',
    'es-ES': 'es_ES',
    'fi-FI': 'fi_FI',
    'fr-BE': 'fr_BE',
    'fr-CH': 'fr_CH',
    'fr-FR': 'fr_FR',
    'hr-HR': 'en_HR',
    'hu-HU': 'hu_HU',
    'it-IT': 'it_IT',
    'nb-NO': 'no_NO',
    'nl-NL': 'nl_NL',
    'no-NO': 'no_NO',
    'pl-PL': 'pl_PL',
    'pt-PT': 'pt_PT',
    'ro-RO': 'en_RO',
    'ru-RU': 'ru_RU',
    'sk-SK': 'sk_SK',
    'sl-SI': 'en_GB',
    'sv-SE': 'sv_SE',
    en: 'en_GB',
    zu: 'en_GB',
};

export { payPalLocaleOfZppLocale };
//# sourceMappingURL=PayPalTypes.js.map
